export const dbWorker = new Worker(new URL('../contexts/db-state/db-worker.ts', import.meta.url))